export const ButtonContent = ({ text }) => {
  return (
    <span className='button__content'>
      <span className='button__text'>
        {text}
      </span>

      <span className='button__hover-icon'>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M4 12h16m0 0-6-6m6 6-6 6"
            stroke="currentcolor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </span>
  );
}
